export default __webpack_public_path__ + "static/media/profit.d4d1bcfb.png";